import { GetSupportCommercialAsync } from '@/api/societe/index';

export default async function getSupportCommercial(categorieVente, societeId) {
  const supportCommerciaux = (await GetSupportCommercialAsync(societeId)).data.result.items;
  const supportCommercial = supportCommerciaux.find((support) => {
    return support.categorieVente === categorieVente;
  });
  if (supportCommercial) return supportCommercial;
}
